/**
 * Encapsulates utility methods for working with questionnaires, sections, questions, variables, and responses
 */

import DerivedVariables from '@/providers/DerivedVariables.js';
import flatten from 'lodash/flatten';

export default {
  findQuestion(questionnaire, qid) {
    const questions = flatten(
      (questionnaire.sections || []).map((section) =>
        (section.questionSections || []).map((qs) => qs.question)
      )
    );
    return questions.find((q) => q.id == qid);
  },

  getDefaultVariableSelections() {
    return {
      derivedVarNames: [],
      questionIds: [],
      variableIds: [],
    };
  },

  getDerivedVariables: function (selectedNames) {
    return Object.values(DerivedVariables.userFilterVariables).map((dv) => {
      return {
        derivedVariable: dv,
        favorite: true,
        selected: selectedNames.includes(dv.name),
      };
    });
  },

  getQuestionnaireSections: function (
    sections,
    selectedQsIds,
    selectedVIds
  ) {
    return sections.map((s) => {
      return {
        section: s,
        questions: s.questionSections.map((qs) => {
          const resQuestion = {
            question: qs.question,
            favorite: true,
            selected: selectedQsIds.includes(qs.question.id),
            variables: qs.question.variables.map((v) => {
              return {
                variable: v,
                favorite: true,
                selected: selectedVIds.includes(v.id),
              };
            }),
            is_available_on_results: qs.is_available_on_results,
            is_on_dashboard: qs.is_on_dashboard,
          };
          resQuestion.indeterminate = this.isIndeterminate(resQuestion);
          return resQuestion;
        }),
      };
    });
  },

  isIndeterminate: function (question) {
    const selectedVars = question.variables.filter((vm) => vm.selected);
    return (
      selectedVars.length > 0 && selectedVars.length < question.variables.length
    );
  },

  filterDerVarsBasedOnFavorites: function (derivedVariables, favorites) {
    const favoritesDerVars = (favorites || {}).derivedVarNames || [];
    return derivedVariables.filter((derVar) =>
      favoritesDerVars.includes(derVar.derivedVariable.name)
    );
  },

  filterQuestionSectionsBasedOnFavorites: function (sections, favorites) {
    const favoritesQsIds = (favorites || {}).questionIds || [];
    const favoritesVIds = (favorites || {}).variableIds || [];
    return sections.reduce((acc, section) => {
      const questions = section.questions.reduce((qAcc, sectionQuestion) => {
        if (favoritesQsIds.includes(sectionQuestion.question.id)) {
          qAcc.push({
            ...sectionQuestion,
            variables: sectionQuestion.variables.filter((v) => {
              return favoritesVIds.includes(v.variable.id);
            }),
          });
        }
        return qAcc;
      }, []);
      if (questions.length > 0) {
        acc.push({ ...section, questions });
      }
      return acc;
    }, []);
  },
};
